/* @flow */
import * as React from 'react';
import classnames from 'classnames/bind';
import { findDOMNode } from 'react-dom';
import { renderPortal } from 'trustar/dom-utils';
import { mergeState } from 'trustar/utils';

import s from './Tip.styl';
const cx = classnames.bind(s);

const open = () => ({ isOpen: true });
const close = () => ({ isOpen: false });

/**
 * A simpler tooltip.
 */
export class Tip extends React.Component {
  props: {
    text: string,
    className?: string,
    tooltipClassName?: string,
    children: React.Element<*>,
  };

  state = {
    isOpen: false,
    position: {
      top: 0,
      left: 0,
    },
  };

  el: $TODO;

  updatePosition = () => {
    try {
      const dom = findDOMNode(this.el);
      // $FlowIgnore: This is what the try-catch is for
      const rect = dom.getBoundingClientRect();
      return {
        top: rect.top - 10, // Adjust top for tooltip on top
        left: rect.left + (rect.width / 2), // Adjust left for tooltip centered
      };
    } catch (err) {
      // Not much to be done here. We should not hit this. Without the dom
      // measurement we can't position the tooltip properly
      return null;
    }
  };

  onMouseOver = (e: SyntheticMouseEvent) => {
    const position = this.updatePosition();

    // Only open the tooltip if the position can be calculated
    if (position) {
      this.setState(mergeState(open, () => ({ position })));
    }
  };

  onMouseOut = (e: SyntheticMouseEvent) => {
    this.setState(close);
  };

  render() {
    const { isOpen } = this.state;
    const { className, tooltipClassName } = this.props;

    return (
      <div className={cx('Tip', className)}>
        <div
          ref={el => { this.el = el; }}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          className={cx('children')}>
          {this.props.children}
        </div>
        {renderPortal(
          <div
            style={this.state.position}
            className={cx('text', { isOpen }, tooltipClassName)}>
            {this.props.text}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/Tip.js